import React from 'react';
import PromoBanner from '../PromoBanner';
import LeadFormSkeleton from '../LeadForms/LeadFormSkeleton';
import InsurancePartnerSlider from '../Sliders/InsurancePartnerSlider';
import SidebarStepper from '../Widgets/SidebarStepper';
import CustomerReview from '../Widgets/CustomerReview';
import SidebarFeature from '../Widgets/SidebarFeature';

const PageTemplate = ({ promoData, brands, popularCarBrands }) =>
  (
    <div>
      {promoData && (
        <div className="flex flex-col promo__banner">
          <PromoBanner sliderImageList={promoData} />
        </div>
      )}
      <div className="flex flex-col mb-4">
        <LeadFormSkeleton
          showRibbon
          showTypeDropdown={false}
          leadFormType={promoData.leadFormCategory}
          leadFormTitle={promoData.leadFormTitle}
          leadFormDescription={promoData.leadFormDescription}
          leadFormCTA={promoData.leadformCta}
          fomo={promoData.fomo}
          discountCode={promoData.discountCode}
          autoBrandList={brands}
          popularCarBrands={popularCarBrands}
          language="id"
        />
      </div>
      <div className="px-2 pb-4 lg:px-0">
        <InsurancePartnerSlider />
      </div>
      <div className="flex flex-col lg:place-content-between gap-5 lg:flex-row">
        <div className="lg:w-2/6">
          <SidebarStepper />
        </div>
        <div className="lg:w-2/6">
          <SidebarFeature />
        </div>
        <div className="lg:w-2/6">
          <CustomerReview />
        </div>
      </div>
    </div>
  );

export default PageTemplate;
